import { Directive, Input, Optional } from '@angular/core';
import { ComboLookupComponent } from '@farris/ui-combo-lookup';
import { LookupGridComponent } from '@farris/ui-lookup';

@Directive({
  selector: '[farris-lookup-binding]'
})
export class FarrisLookupBindingDirective {
  @Input() lookupType: string;
  @Input('farris-lookup-binding')
  public set lookupValue(value: any) {
    if (this.lookupType === 'lookup' && this.lookup) {
      this.lookup.writeValue(value);
    } else if (this.lookupType === 'comboLookup' && this.comboLookup) {
      this.comboLookup.writeValue(value);
    }
  }
  constructor(@Optional() private lookup: LookupGridComponent, @Optional() private comboLookup: ComboLookupComponent) { }
}